import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopNavigation from '../../components/base/TopNavigation';
import BottomNavigation from '../../components/base/BottomNavigation';

interface Photo {
  id: number;
  url: string;
  title: string;
  date: string;
}

export default function GalleryPage() {
  const { t } = useTranslation();
  const [photos] = useState<Photo[]>([
    {
      id: 1,
      url: 'https://public.readdy.ai/ai/img_res/a1335080d0dbfef98e788fdbfbe2b382.jpg',
      title: 'عشاء العائلة',
      date: '2024-01-15'
    },
    {
      id: 2,
      url: 'https://readdy.ai/api/search-image?query=Children%20playing%20in%20beautiful%20garden%2C%20sunny%20day%2C%20colorful%20playground%20equipment%2C%20happy%20kids%20running%20and%20laughing%2C%20family%20backyard%2C%20realistic%20photography&width=300&height=300&seq=2&orientation=squarish',
      title: 'لعب الأطفال',
      date: '2024-01-10'
    },
    {
      id: 3,
      url: 'https://readdy.ai/api/search-image?query=Family%20vacation%20at%20beautiful%20beach%2C%20crystal%20clear%20water%2C%20palm%20trees%2C%20family%20members%20enjoying%20beach%20activities%2C%20summer%20vacation%2C%20realistic%20photography&width=300&height=300&seq=3&orientation=squarish',
      title: 'إجازة الصيف',
      date: '2024-01-05'
    },
    {
      id: 4,
      url: 'https://readdy.ai/api/search-image?query=Birthday%20celebration%20with%20family%2C%20colorful%20balloons%2C%20birthday%20cake%20with%20candles%2C%20happy%20family%20members%20celebrating%2C%20indoor%20party%20decoration%2C%20realistic%20photography&width=300&height=300&seq=4&orientation=squarish',
      title: 'عيد ميلاد سعيد',
      date: '2024-01-01'
    },
    {
      id: 5,
      url: 'https://readdy.ai/api/search-image?query=Family%20cooking%20together%20in%20modern%20kitchen%2C%20parents%20and%20children%20preparing%20meal%2C%20fresh%20ingredients%2C%20warm%20family%20bonding%20moment%2C%20realistic%20photography&width=300&height=300&seq=5&orientation=squarish',
      title: 'طبخ جماعي',
      date: '2023-12-28'
    },
    {
      id: 6,
      url: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20at%20home%2C%20cozy%20living%20room%2C%20family%20members%20watching%20TV%20together%2C%20popcorn%20and%20snacks%2C%20comfortable%20sofa%2C%20realistic%20photography&width=300&height=300&seq=6&orientation=squarish',
      title: 'ليلة الأفلام',
      date: '2023-12-25'
    }
  ]);

  const [selectedPhoto, setSelectedPhoto] = useState<Photo | null>(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <TopNavigation 
        title={t('familyPhotos')} 
        rightAction={
          <button className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-add-line text-white text-lg"></i>
          </button>
        }
      />
      
      <div className="pt-16 pb-20 px-4">
        <div className="grid grid-cols-2 gap-3">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="relative bg-white rounded-xl overflow-hidden shadow-sm cursor-pointer transform transition-all duration-200 hover:scale-105"
              onClick={() => setSelectedPhoto(photo)}
            >
              <div className="aspect-square">
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-gray-800 mb-1">{photo.title}</h3>
                <p className="text-xs text-gray-500">{photo.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Add Photo Button */}
        <button className="fixed bottom-24 left-4 right-4 bg-[#5B9BD5] text-white py-4 rounded-xl font-semibold shadow-lg flex items-center justify-center space-x-2 space-x-reverse">
          <i className="ri-camera-fill text-lg"></i>
          <span>{t('addPhoto')}</span>
        </button>
      </div>

      {/* Photo Modal */}
      {selectedPhoto && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl overflow-hidden max-w-sm w-full">
            <div className="relative">
              <img
                src={selectedPhoto.url}
                alt={selectedPhoto.title}
                className="w-full aspect-square object-cover object-top"
              />
              <button
                onClick={() => setSelectedPhoto(null)}
                className="absolute top-4 right-4 w-8 h-8 bg-black/50 rounded-full flex items-center justify-center"
              >
                <i className="ri-close-line text-white text-lg"></i>
              </button>
            </div>
            <div className="p-4">
              <h3 className="text-lg font-bold text-gray-800 mb-2">{selectedPhoto.title}</h3>
              <p className="text-sm text-gray-600">{selectedPhoto.date}</p>
            </div>
          </div>
        </div>
      )}

      <BottomNavigation />
    </div>
  );
}
